import * as React from 'react'
import Alert from '@mui/material/Alert'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

export function NoConditionsCard() {
  return (
    <Box>
      <Alert severity="info">
        <Typography
          variant="body1"
          sx={{ fontFamily: 'Source Sans Pro Semibold' }}
        >
          No conditions have been created. This is required to create an
          assignment rule.
        </Typography>
      </Alert>
    </Box>
  )
}
